import { dateService } from './dateService';

const STORAGE_KEY_RESERVATIONS = 'cabanas_reservations';

export const reservationService = {
    // Get all reservations
    getReservations: () => {
        const stored = localStorage.getItem(STORAGE_KEY_RESERVATIONS);
        return stored ? JSON.parse(stored) : [];
    },

    // Add a new reservation
    addReservation: (reservation) => {
        const reservations = reservationService.getReservations();
        const newReservation = {
            id: Date.now().toString(), // Simple ID generation
            ...reservation,
            createdAt: new Date().toISOString()
        };

        const newReservations = [...reservations, newReservation];
        localStorage.setItem(STORAGE_KEY_RESERVATIONS, JSON.stringify(newReservations));

        // Automatically block the dates
        dateService.blockRange(reservation.checkIn, reservation.checkOut);

        return newReservation;
    },

    // Remove a reservation
    removeReservation: (id) => {
        const reservations = reservationService.getReservations();
        const reservationToRemove = reservations.find(r => r.id === id);

        if (reservationToRemove) {
            const newReservations = reservations.filter(r => r.id !== id);
            localStorage.setItem(STORAGE_KEY_RESERVATIONS, JSON.stringify(newReservations));

            // Automatically unblock the dates
            dateService.unblockRange(reservationToRemove.checkIn, reservationToRemove.checkOut);
        }
    }
};
